import { cropConnectApiClient } from '../services/cropConnectApiClient';

export const handleDocumentPreview = async (id: string) => {
  try {
    const response = await cropConnectApiClient.downloadDocument(id);
    if (response && response.data) {
      const file = response.data;

      // Common file types that browsers can preview
      const previewableTypes = {
        'application/pdf': true,
        'image/jpeg': true,
        'image/png': true,
        'image/gif': true,
        'image/webp': true,
        'text/plain': true,
        'text/html': true,
        'audio/mpeg': true,
        'audio/wav': true,
        'video/mp4': true,
        'video/webm': true,
      };

      if (previewableTypes[file.type as keyof typeof previewableTypes]) {
        const url = window.URL.createObjectURL(file);
        // Open in a new tab for preview
        window.open(url, '_blank');
      } else {
        console.error('File type not supported for preview:', file.type);
      }
      // Clean up the URL object after a short delay to ensure the browser has time to open it
    } else {
      console.error('Failed to fetch document data');
    }
  } catch (error) {
    console.error('Error opening document:', error);
  }
};

export const handleGeneralDocumentPreview = async (
  widgetId: string,
  documentId: string
) => {
  try {
    const file = await cropConnectApiClient.downloadGeneralDocument(
      widgetId,
      documentId
    );
    console.log(file);
    if (file) {
      const blob = new Blob([file.data], {
        type: file.headers['content-type'],
      });
      const fileURL = window.URL.createObjectURL(blob);
      window.open(fileURL, '_blank');
    } else {
      console.error('Failed to fetch document data');
    }
  } catch (error) {
    console.error('Error opening document:', error);
  }
};

export const handleGeneralDocumentInMyTaskPreview = async (id: number) => {
  try {
    const response = await cropConnectApiClient.downloadGeneralDocumentForTask(
      id,
      '123'
    );
    if (response && response.data) {
      const blob = new Blob([response.data], {
        type: response.headers['content-type'],
      });
      const fileURL = window.URL.createObjectURL(blob);
      window.open(fileURL, '_blank');
    } else {
      console.error('Failed to fetch document data');
    }
  } catch (error) {
    console.error('Error opening document:', error);
  }
};
